import { Component } from '@angular/core';

@Component({
  template: `<div class="alert alert-danger"><p>La pàgina a la què voleu accedir no existeix.</p></div>`,
})
export class NotFoundComponent  {
}
